import React from 'react';
import Config from './config/config';
import ReactDOM from 'react-dom';
import './styles/index.css';
import Application from './App';
import './translation/i18n'
import { GoogleOAuthProvider } from '@react-oauth/google';
import { BrowserRouter } from 'react-router-dom';


ReactDOM.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={Config.defaults.googleClientId} >
      <BrowserRouter>
        <Application />
      </BrowserRouter>
    </GoogleOAuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);